import { render, staticRenderFns } from "./mainSafetyHealthyTargetDetail.vue?vue&type=template&id=75f516f6"
import script from "./mainSafetyHealthyTargetDetail.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyTargetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f516f6')) {
      api.createRecord('75f516f6', component.options)
    } else {
      api.reload('75f516f6', component.options)
    }
    module.hot.accept("./mainSafetyHealthyTargetDetail.vue?vue&type=template&id=75f516f6", function () {
      api.rerender('75f516f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyTargetDetail.vue"
export default component.exports